import { Component } from '@verndale/core';
import Swiper, { Navigation } from 'swiper';
import { KEYS } from '../constants';

Swiper.use([Navigation]);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $thumbs: this.el._$('.masthead-system-detail__thumbs'),
      $thumb: this.el._$$('.masthead-system-detail__thumb'),
      $previews: this.el._$('.masthead-system-detail__previews'),
      $prev: this.el._$('.masthead-system-detail__nav--prev'),
      $next: this.el._$('.masthead-system-detail__nav--next'),
      $videos: this.el._$('.swiper-container')._$$('.video__container'),
      $container: this.el._$('.swiper-container')
    };

    this.playVidLabel = this.el.dataset.playLabel || 'Play video';
    this.activeThumbClass = 'masthead-system-detail__thumb--active';
    this.setActiveThumb(0);
    this.initSlider();
    this.fixVideoKeyboardControl();
  }

  addListeners() {
    this.dom.$thumb.forEach((el, i) =>
      el._on('click', this.handleThumbClick.bind(this, i))
    );
    this.preview.on('activeIndexChange', this.handlePreviewChange.bind(this));
  }

  initSlider() {
    this.el.dataset.itemsCount = this.dom.$thumb?.length;

    this.thumbs = new Swiper(this.dom.$thumbs, {
      spaceBetween: 18,
      slidesPerView: 4,
      allowTouchMove: false,
      centerInsufficientSlides: true,
      navigation: {
        prevEl: this.dom.$prev,
        nextEl: this.dom.$next
      },
      breakpoints: {
        768: {
          slidesPerView: 6,
          spaceBetween: 20
        }
      }
    });

    this.preview = new Swiper(this.dom.$previews, {
      allowTouchMove: false
    });
  }

  handleThumbClick(index) {
    if (this.preview.activeIndex !== index) {
      this.preview.slideTo(index);
    } else {
      const videoContainer = this.dom.$container
        ._$$('.swiper-slide')
        [this.preview.activeIndex]?._$('.video__container');
      if (videoContainer) videoContainer.click();
    }
  }

  handlePreviewChange() {
    this.setActiveThumb(this.preview.activeIndex);

    this.el._$('.video__container iframe')?.remove();

    const isVideoVisible = this.dom.$container
      ._$$('.swiper-slide')
      [this.preview.activeIndex]?._$('.video__container');

    if (isVideoVisible) {
      this.dom.$container.setAttribute('tabindex', '0');
      this.dom.$container.setAttribute('aria-role', 'button');
      this.dom.$container.setAttribute('aria-label', this.playVidLabel);
    } else {
      this.dom.$container.setAttribute('tabindex', '-1');
      this.dom.$container.removeAttribute('aria-role');
      this.dom.$container.removeAttribute('aria-label');
    }
  }

  handleVideoContainerKeyPress(e) {
    if (e.keyCode !== KEYS.ENTER && e.keyCode !== KEYS.SPACE) return;
    e.target._$('.video__container')?.click();
  }

  setActiveThumb(index) {
    this.dom.$thumb.forEach(($thumb, i) => {
      const shouldAddClass = index === i;
      $thumb.classList.toggle(this.activeThumbClass, shouldAddClass);
    });
  }

  fixVideoKeyboardControl() {
    if (!this.dom.$videos || this.dom.$videos.length < 1) return;
    const isVideoVisible = this.dom.$container
      ._$$('.swiper-slide')
      [this.preview.activeIndex]?._$('.video__container');

    this.dom.$videos.forEach($video => {
      $video.setAttribute('tabindex', '-1');
    });

    if (isVideoVisible) {
      this.dom.$container.setAttribute('tabindex', '0');
      this.dom.$container.setAttribute('aria-role', 'button');
      this.dom.$container.setAttribute('aria-label', this.playVidLabel);
    }

    this.dom.$container._on(
      'keypress',
      this.handleVideoContainerKeyPress.bind(this)
    );
  }
}

export default Module;
